import { render, staticRenderFns } from "./dConfirm.vue?vue&type=template&id=2f496d2a&scoped=true&"
import script from "./dConfirm.vue?vue&type=script&lang=js&"
export * from "./dConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f496d2a",
  null
  
)

export default component.exports